export default __webpack_public_path__ + "static/media/6s.24e72d36.svg";